import React, { useState, useRef } from 'react';
import './TruncatedText.css';

const TruncatedText = ({ text, limit = 20, className = "" }) => {
  const [showTooltip, setShowTooltip] = useState(false);
  const [openUpward, setOpenUpward] = useState(false);
  const wrapperRef = useRef(null);
  
  if (!text) return null;
  
  const isTextTruncated = text.length > limit;
  const displayText = isTextTruncated ? `${text.slice(0, limit)}...` : text;
  
  const handleMouseEnter = () => {
    if (wrapperRef.current) {
      const rect = wrapperRef.current.getBoundingClientRect();
      const spaceBelow = window.innerHeight - rect.bottom;
      setOpenUpward(spaceBelow < 160);
    }
    setShowTooltip(true);
  };

  return (
    <div 
      ref={wrapperRef}
      className={`truncated-text-wrapper ${className}`}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={() => setShowTooltip(false)}
    >
      <span className="truncated-text">{displayText}</span>
      
      {isTextTruncated && showTooltip && (
        <div className={`truncated-tooltip ${openUpward ? 'open-upward' : ''}`}>
          {text}
        </div>
      )}
    </div>
  );
};

export default TruncatedText;